import ModalProvider from "contexts/ModalProvider";
import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import useBookingPage from "services/store/BookingPage";
import useLoadedStore from "services/store/LoadedPage";
import useProfileStore from "services/store/ProfileModule";

function Layouts({ children }) {
  const state = useBookingPage(state => state )
  const booking = useLoadedStore(state => state )
  const profile = useProfileStore(state => state )
  
  // console.log('state ALL >>', state)
  // console.log('register ALL >>', state)
  console.log('state ALL >>', profile)
  return <ModalProvider>
    
    {children}
  </ModalProvider>;
}

export default Layouts;
